import './App.css';
import Intro from './modules/intro/intro';
import { BrowserRouter as Router } from "react-router-dom";

import "./Animate.css"
import { ThemeProvider, createTheme } from '@mui/material/styles';
const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1440,
            xxl: 1920,
            custom: 1800,
            maxwithnav: 1700,
            maxwithnav1: 1500,
        },
    },
});


function App() {

    return (
        <Router>
            <ThemeProvider theme={theme}>
                <Intro />
            </ThemeProvider>
        </Router>
    );
}

export default App;
